var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("订单模块管理")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "淘宝比价订单跳转入口",
                        prop: "tbComparativeEntry",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.tbComparativeEntry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tbComparativeEntry", $$v)
                          },
                          expression: "form.tbComparativeEntry",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#606266" } }, [
                        _vm._v(
                          "比价订单跳转页面设置方式：先去活动管理-自定义页面-创建“淘宝比价订单”页，创建后复制卡片链接配置到此即可。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "拼多多比价订单跳转入口",
                        prop: "pddComparativeEntry",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.pddComparativeEntry,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "pddComparativeEntry", $$v)
                          },
                          expression: "form.pddComparativeEntry",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { color: "#606266" } }, [
                        _vm._v(
                          "比价订单跳转页面设置方式：先去活动管理-自定义页面-创建“淘宝比价订单”页，创建后复制卡片链接配置到此即可。"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "底部提示横幅", prop: "agent" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.agent,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "agent", $$v)
                            },
                            expression: "form.agent",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.agent === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "底部横幅提示文案",
                            prop: "bottomCopyright",
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "800px" },
                            attrs: {
                              placeholder: "请输入",
                              autosize: "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.form.bottomCopyright,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bottomCopyright", $$v)
                              },
                              expression: "form.bottomCopyright",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效订单查询功能" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.orderSwitch,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "orderSwitch", $$v)
                            },
                            expression: "form.orderSwitch",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效订单弹窗提示文案" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: {
                          placeholder: "请输入",
                          autosize: "",
                          type: "textarea",
                        },
                        model: {
                          value: _vm.form.orderText,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "orderText", $$v)
                          },
                          expression: "form.orderText",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n              保存\n            ")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }